<script lang="ts">
    import type {Rating, Rec} from 'typings/portaro.be.types';
    import {onMount} from 'svelte';
    import {getInjector, getLocalization} from 'core/svelte-context/context';
    import {KpRatingPresenter} from './kp-rating.presenter';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import RatingStar from './RatingStar.svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {range} from 'shared/utils/array-utils';

    export let record: Rec;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpRatingPresenter);
    const starCount = 5;

    let loading = true;
    let rating: Rating | undefined;
    let hoveredStarValue = 0;

    onMount(async () => {
        rating = await presenter.loadRating(record);
        loading = false;
    });

    const handleRateClick = async (value: number) => {
        const newRating = await presenter.rate(record, value);

        if (exists(newRating)) {
            rating = newRating;
        }
    }

    const handleStarMouseEnter = (starValue: number) => {
        hoveredStarValue = starValue;
    }

    const handleStarButtonsMouseLeave = () => {
        hoveredStarValue = 0;
    }
</script>

{#if rating}
    <div class="rating">
        {#if rating.count === 0}
            <div>{localize(/* @kp-localization detail.dokumentZatimNebylOhodnocen */ 'detail.dokumentZatimNebylOhodnocen')}</div>
        {/if}

        {#if rating.count > 0}
            <div class="rating-values">
                <span>{localize(/* @kp-localization detail.hodnoceni */ 'detail.hodnoceni')}: <span
                        class="value">{rating.value.toFixed(1)}</span></span>
                <span>({localize(/* @kp-localization detail.pocetHodnoceni */ 'detail.pocetHodnoceni')}: <span
                        class="value">{rating.count}</span>)</span>
            </div>
        {/if}

        <div class="star-buttons-container"
             role="slider"
             aria-valuemin="0"
             aria-valuemax={starCount}
             aria-valuenow={rating.value}
             tabindex="0"
             on:mouseleave={() => handleStarButtonsMouseLeave()}>

            {#each range(1, starCount) as value}
                <RatingStar hovered={value <= hoveredStarValue}
                            selected={(hoveredStarValue === 0 && value <= rating.value) || (hoveredStarValue > 0 && value <= hoveredStarValue)}
                            maxValue={starCount}
                            {value}
                            on:click={() => handleRateClick(value)}
                            on:mouseenter={() => handleStarMouseEnter(value)}/>
            {/each}
        </div>

        {#if rating.result}
            <div class="error">
                {rating.result}
            </div>
        {/if}
    </div>
{/if}

{#if loading}
    <KpLoadingBlock size="xs"/>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .rating {
        margin: 16px 0;
        display: flex;
        flex-direction: column;
        gap: @spacing-s;

        .rating-values .value {
            font-weight: 500;
        }

        .star-buttons-container {
            display: flex;
            align-items: center;
            width: min-content;
            gap: 2px;
        }
    }
</style>